import { render, staticRenderFns } from "./ProfessorGrauAcademicoCard.vue?vue&type=template&id=4e884c42&scoped=true"
import script from "./ProfessorGrauAcademicoCard.vue?vue&type=script&lang=js"
export * from "./ProfessorGrauAcademicoCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorGrauAcademicoCard.vue?vue&type=style&index=0&id=4e884c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e884c42",
  null
  
)

export default component.exports